import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDBodyText, FDTitleText } from '@facet-wealth/design';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import AssumptionsOverride from './AssumptionsOverride';

function AdvisedPendingTransactionsLayout() {
  const { resource } = useMetaLayoutContext();
  return (
    <Box>
      <FDBodyText value={`${resource.attr('name')}`} />
      <MetaControlField attr="shouldApply" />
    </Box>
  );
}

function CurrentMonthConfigurationLayout() {
  const { resource } = useMetaLayoutContext();
  return (
    <Box>
      <MetaControlField attr={'useExpectedStartingCashOnHandValue'} />
      <MetaControlField attr={'expectedStartingCashOnHandValue'} />
      <FDTitleText value={'Current Month Transactions'} />
      <MetaCollectionFormInline
        FormProps={{
          layout: AdvisedPendingTransactionsLayout,
          noIndividualSubmitButtons: true,
        }}
        collection={resource.attr('advisedPendingTransactions')}
      />
    </Box>
  );
}


const styles = theme => ({
  root: {},
  actions: {
    backgroundColor: 'white',
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
    padding: theme.spacing(1, 0),
  },
  form: {
    padding: theme.spacing(2, 0),
  },
});

const LABEL = 'Current Month';
const CurrentMonthConfiguration = ({ classes }) => {
  const { resource } = useMetaLayoutContext();
  const { displaySuccess } = useSnackbarContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const canSubmit = resource.meta().canSubmit();

  return (
    <Box className={classes.root}>
      <MetaFormInline
        classes={{
          root: classes.form,
        }}
        SubmitButtonProps={{
          color: 'primary',
          text: 'Save',
          round: true,
          fullWidth: true,
        }}
        ActionProps={{
          className: classes.actions,
        }}
        noIndividualSubmitButtons={!canSubmit}
        onSubmit={() => {
          displaySuccess(`${LABEL} Saved`);
          refreshPageContentCollection();
        }}
        layout={CurrentMonthConfigurationLayout}
        resource={resource}
        metaOverrideSet={AssumptionsOverride}
      />
    </Box>
  );
};

CurrentMonthConfiguration.defaultProps = {};

CurrentMonthConfiguration.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(CurrentMonthConfiguration);
